export default "__VITE_ASSET__DF12e5Y$__"